import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import LicenseCard from "./LicenseInfoSection";
import * as licenseService from "./licenseService";
import { Spinner } from "../view/Spinner";

function NewLicensePage() {

    const history = useHistory();
    const [loading, setLoading] = useState(true);

    const fetchData = async () => {
        try {
            await licenseService.loadLicense();
            await licenseService.loadMachineData();
            setLoading(false);
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [history.location]);

    return (
        <div className="license-page p-5">
            {loading && <Spinner />}
            <LicenseCard />
        </div>
    )

}


export default NewLicensePage;